import { render, staticRenderFns } from "./ReleaseOrder.vue?vue&type=template&id=41a621fd"
import script from "./ReleaseOrder.vue?vue&type=script&lang=js"
export * from "./ReleaseOrder.vue?vue&type=script&lang=js"
import style0 from "./ReleaseOrder.vue?vue&type=style&index=0&id=41a621fd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports